import React from "react"
import clsx from "clsx"
import { useDispatch, useSelector } from "react-redux"
import {
  COLUMNS,
  DELIVERY_STATUS_COLUMN,
  getCurrentSort,
  setCurrentSort,
} from "reduxSlices/surveyRecipientTableSlice"
import { CircularIconButton } from "shared/buttons"
import TableHeadSortIcon from "shared/Table/TableHeader/TableHeadSortIcon"

const BASE_LABEL_CLASS = "flex items-center gap-1 text-dark tracking-tight font-medium text-sm cursor-pointer"

const SurveyRecipientListHeader = () => {
  const dispatch = useDispatch()
  const currentSort = useSelector(getCurrentSort)

  return (
    <div className="grid grid-cols-1-auto items-center">
      <div className="p-4 survey-recipient-list-row">
        {
          COLUMNS.map((column) => {
            const allowOverflow = column === DELIVERY_STATUS_COLUMN

            return (
              <span
                key={column.value}
                className={clsx(BASE_LABEL_CLASS, !allowOverflow && "overflow-hidden")}
                onClickCapture={() => dispatch(setCurrentSort(column))}
              >
                <span className={allowOverflow ? "whitespace-nowrap" : "truncate"}>{column.label}</span>
                <span className="shrink-0">
                  <TableHeadSortIcon column={column} currentSort={currentSort} />
                </span>
              </span>
            )
          })
        }
      </div>
      <div className="p-1 invisible" aria-hidden="true">
        <CircularIconButton icon="chevron-down" ariaLabel="placeholder" onClick={() => {}} />
      </div>
    </div>
  )
}

export default SurveyRecipientListHeader
